import React from 'react';
import ReactDOM from 'react-dom/client';
import '../client/i18n';
import frFR from 'antd/locale/fr_FR';
import { ConfigProvider } from 'antd';
import theme from '@client/theme/theme';
import AppQueryClientProvider from '@client/providers/QueryClientProvider';
import { NuqsAdapter } from 'nuqs/adapters/react';
import ProductSearchPage from '@client/feature/product/searchPage';

const root = document.getElementById('productSearch');

/**
 * This app is responsible for the product search
 *
 * @returns {Element}
 * @constructor
 */
const ProductSearchApp = () => {
  return (
    <NuqsAdapter>
      <AppQueryClientProvider>
        <ConfigProvider theme={theme} locale={frFR}>
          <ProductSearchPage />
        </ConfigProvider>
      </AppQueryClientProvider>
    </NuqsAdapter>
  );
};

/**
 * Render the application
 * we can add redux provider here
 */
ReactDOM.createRoot(root).render(<ProductSearchApp />);
